import React from "react";

import SorterSVG from "Components/Admin/assets/SorterSVG";
import Button from "Components/Admin/Button";

const HeaderSorter = ({title = 'Title', selectedCount, handleSelectAll}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (handleSelectAll) handleSelectAll();
  }

  return (
    <div className="title-header">
      <span className="title-header__text">{title}</span> <SorterSVG/>
      {selectedCount && (
        <Button
          variant="simple"
          className="title-header__btn"
          onClick={handleClick}
        >
          Select All <span className="title-header__counter">{selectedCount} lines</span>
        </Button>
      )}
    </div>
  )
};

export default HeaderSorter;
